// extracted by mini-css-extract-plugin
module.exports = {"root":"statisticsUser_root__2em5-","message":"statisticsUser_message__12MC3","tableWrapper":"statisticsUser_tableWrapper__2Spca"};